/**
 * Pagination constants
 */
export const PAGINATION = {
  EVENTS_PER_PAGE: 10,
  DEFAULT_PAGE: 1
} as const;
